import { render, staticRenderFns } from "./ScatterPlotChart.vue?vue&type=template&id=1ba43086&"
import script from "./ScatterPlotChart.vue?vue&type=script&lang=ts&"
export * from "./ScatterPlotChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports